import axios from './axios-auth'

const getFeed = (feedUrl) =>
  new Promise((resolve, reject) => {
    const params = {
      url: feedUrl
    }
    axios({
      url: '/feed',
      method: 'GET',
      params: params
    })
      .then((resp) => {
        resolve(resp.data.items)
      })
      .catch((err) => {
        reject(err)
      })
  })

export { getFeed }
